import { Switch } from '@material-ui/core';
import { FC } from 'react';
import { useStyles } from './styles';
import { SwitcherProps } from './types';
import { Tooltip } from '@material-ui/core';
export const Switcher: FC<SwitcherProps> = ({ checked, onClick, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.wraper}>
      <Tooltip title='enable/disable' classes={{ tooltip: classes.tooltip }}>
        <Switch
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
        />
      </Tooltip>
    </div>
  );
};
